export function updateSeo(
  doc: Document,
  title: string,
  description: string,
  keywords?: string,
  canonicalPath?: string,
  imageUrl?: string,
  robotsContent = 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1',
  ogType = 'website',
) {
  const head = doc.head;
  if (!head) {
    return;
  }

  const origin = doc.location?.origin || '';
  const baseUrl = origin || doc.location?.href || 'http://localhost';
  const canonicalUrl = canonicalPath ? new URL(canonicalPath, baseUrl).toString() : doc.location?.href || baseUrl;
  const resolvedImageUrl = imageUrl ? new URL(imageUrl, baseUrl).toString() : null;

  doc.title = title;

  setOrCreateMeta(head, 'description', description);
  if (keywords) {
    setOrCreateMeta(head, 'keywords', keywords);
  }
  setOrCreateMeta(head, 'robots', robotsContent);
  setOrCreateMeta(head, 'og:title', title, 'property');
  setOrCreateMeta(head, 'og:description', description, 'property');
  setOrCreateMeta(head, 'og:url', canonicalUrl, 'property');
  setOrCreateMeta(head, 'og:type', ogType, 'property');
  setOrCreateMeta(head, 'og:site_name', 'VENTORA', 'property');
  setOrCreateMeta(head, 'twitter:card', resolvedImageUrl ? 'summary_large_image' : 'summary');
  setOrCreateMeta(head, 'twitter:title', title);
  setOrCreateMeta(head, 'twitter:description', description);

  if (resolvedImageUrl) {
    setOrCreateMeta(head, 'og:image', resolvedImageUrl, 'property');
    setOrCreateMeta(head, 'og:image:alt', title, 'property');
    setOrCreateMeta(head, 'twitter:image', resolvedImageUrl);
    setOrCreateMeta(head, 'twitter:image:alt', title);
  }

  setOrCreateCanonical(head, canonicalUrl);
}

export function upsertJsonLd(doc: Document, id: string, data: Record<string, unknown>) {
  removeJsonLd(doc, id);

  const script = doc.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.setAttribute('data-seo-jsonld', id);
  script.textContent = JSON.stringify(data);
  doc.head?.appendChild(script);
}

export function removeJsonLd(doc: Document, id: string) {
  doc.querySelector(`script[data-seo-jsonld="${id}"]`)?.remove();
}

function setOrCreateMeta(head: HTMLHeadElement, name: string, content: string, attribute: 'name' | 'property' = 'name') {
  const selector = `${attribute}="${name}"`;
  let tag = head.querySelector(`meta[${selector}]`) as HTMLMetaElement | null;

  if (!tag) {
    tag = head.ownerDocument.createElement('meta');
    tag.setAttribute(attribute, name);
    head.appendChild(tag);
  }

  tag.setAttribute('content', content);
}

function setOrCreateCanonical(head: HTMLHeadElement, href: string) {
  let link = head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

  if (!link) {
    link = head.ownerDocument.createElement('link');
    link.setAttribute('rel', 'canonical');
    head.appendChild(link);
  }

  link.setAttribute('href', href);
}
